import el from "@cypherpotato/el";
import { api } from "../api";
import { formatDateTime, formatNumber } from "../ui/format";
import { runOperation } from "../ui/operation";
import { Icon } from "./icon";
import { Table, TableActionCell, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "./table";
import { MutedText } from "./text";

export function CollectionPickerControl({ allowNone = false, multiple = false, value }) {

    const collections = el.state.create([]);

    const selectedCollections = el.state.create(
        multiple
            ? (Array.isArray(value) ? value : (value ? [value] : []))
            : value
    );

    runOperation("Fetching collections...", async () => {
        const response = await api.getJson("/api/v1/collections");
        collections.value = response.data;
    });

    function isSelected(colId) {
        if (multiple) {
            return selectedCollections.value.includes(colId);
        }
        return selectedCollections.value === colId;
    }

    function toggleSelection(colId) {
        if (multiple) {
            const current = selectedCollections.value;
            if (current.includes(colId)) {
                selectedCollections.value = current.filter(id => id !== colId);
            } else {
                selectedCollections.value = [...current, colId];
            }
        } else {
            selectedCollections.value = colId;
        }
    }

    function clearSelection() {
        if (multiple) {
            selectedCollections.value = [];
        } else {
            selectedCollections.value = null;
        }
    }

    return el.state.listening([collections, selectedCollections], () =>
        Table(
            {
                $properties: {
                    value: {
                        get() {
                            return selectedCollections.value;
                        },
                        set(value) {
                            if (multiple) {
                                selectedCollections.value = Array.isArray(value) ? value : (value ? [value] : []);
                            } else {
                                selectedCollections.value = value;
                            }
                        }
                    }
                },
                classList: ["selectable"]
            },
            TableHeader(
                TableHeaderCell("Name"),
                TableHeaderCell("Created at"),
                TableHeaderCell("Document count")
            ),
            TableBody(
                allowNone && TableRow(
                    TableCell(MutedText(multiple ? "(Clear selection)" : "(None)")),
                    TableCell(),
                    TableCell(),
                    {
                        onClick() {
                            clearSelection();
                        },
                        classList: [
                            (multiple ? selectedCollections.value.length === 0 : selectedCollections.value === null) && "highlighted"
                        ]
                    }
                ),
                collections.value.map(col =>
                    TableRow(
                        TableCell(col.name),
                        TableCell(formatDateTime(col.createdAt)),
                        TableCell(
                            el("div",
                                formatNumber(col.documentCount.totalDocuments),
                                el("span.highlighted-only.selected-icon",
                                    Icon("check-line")
                                ),
                            )
                        ),
                        {
                            onClick() {
                                toggleSelection(col.id);
                            },
                            classList: [isSelected(col.id) && "highlighted"]
                        }
                    )
                )
            )
        )
    );
}
